import { BaseProviderInstanceResourceModel } from '../base-provider-instance-resource-model';
import { ReportProfileAlertBaseModel } from '../profile/report-profile-alert-base-model';

export class ReportProfileAlertResourceBaseModel extends ReportProfileAlertBaseModel {
  providerInstanceResource: BaseProviderInstanceResourceModel;
}
